import IdToPayTable from './lookupTable';
import { SupportedPayTable } from './types';

const lookupDisplayName = (id: SupportedPayTable): string => IdToPayTable[id].name;

export default lookupDisplayName;
